import { useDeletePhonecentersSysModel } from "./api/deletePhonecentersSysModel";
import { Button } from "reactstrap";


const DeletePhonecentersSysModel = ({handleCloseModal, phonecentersSysModelId}: DeletePhonecentersSysModelProps)  => {
  
  const deletePhonecentersSysModelMutation = useDeletePhonecentersSysModel({ phonecentersSysModelId});
  const handleSubmit = async (): Promise<void> => {
    deletePhonecentersSysModelMutation.mutateAsync({ 
      phonecentersSysModelId: phonecentersSysModelId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Μοντέλο;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeletePhonecentersSysModelProps{
  phonecentersSysModelId: number;
  handleCloseModal: () => void;
}

export default DeletePhonecentersSysModel;